<template>
  <CrudForm
    :title="title"
    :labelSubmit="labelSubmit"
    :storeName="storeName"
    parentStoreName="Notification_prices"
    :submit="submit"
    :canCancel="false"
    :canSubmit="false"
    :status="status"
  >
    <ValidationObserver ref="validator" v-slot="{}">
      <v-row justify="center">
        <v-col cols="4">
          <v-row>
            <v-col>
              <h2 class="text-center">Old Product Price</h2>
            </v-col>
          </v-row>
          <v-row>
            <v-expansion-panels focusable>
              <v-expansion-panel
                v-for="(name, i) in Object.keys(data.old_data)"
                :key="i"
              >
                <v-expansion-panel-header>
                  <h4>{{ namePascalCase(name) }}</h4>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-list>
                    <v-row
                      v-if="!data.old_data[name]"
                      class="justify-center pt-3"
                    >
                      <p class="text-center">No data found</p>
                    </v-row>
                    <template
                      v-else
                      v-for="(item, index) in Object.keys(data.old_data[name])"
                    >
                      <v-row
                        :key="index"
                        v-if="removed_attributes.indexOf(item) === -1 && removed_by_item[name] && removed_by_item[name].indexOf(item) === -1"
                      >
                        <v-col
                          class="ma-0 pa-2 blue-grey--text font-weight-bold"
                          >{{ namePascalCase(item) }}</v-col
                        >
                        <v-col class="ma-0 pa-2">{{
                          data.old_data[name][item]
                        }}</v-col>
                        <v-col class="ma-0 pa-0" cols="12">
                          <v-divider></v-divider>
                        </v-col>
                      </v-row>
                    </template>
                  </v-list>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-row>
        </v-col>
        <v-col cols="4">
          <v-row>
            <v-col>
              <h2 class="text-center">New Product Price</h2>
            </v-col>
          </v-row>
          <v-row>
            <v-expansion-panels focusable>
              <v-expansion-panel
                v-for="(name, i) in Object.keys(data.new_data)"
                :key="i"
              >
                <v-expansion-panel-header>
                  <h4>{{ namePascalCase(name) }}</h4></v-expansion-panel-header
                >
                <v-expansion-panel-content>
                  <v-list>
                    <v-row
                      v-if="!data.new_data[name]"
                      class="justify-center pt-3"
                    >
                      <p class="text-center">No data found</p>
                    </v-row>
                    <template
                      v-else
                      v-for="(item, index) in Object.keys(data.new_data[name])"
                    >
                      <v-row
                        :key="index"
                        v-if="removed_attributes.indexOf(item) === -1 && removed_by_item[name] && removed_by_item[name].indexOf(item) === -1"
                      >
                        <v-col
                          class="ma-0 pa-2 blue-grey--text font-weight-bold"
                          >{{ namePascalCase(item) }}</v-col
                        >
                        <v-col class="ma-0 pa-2">{{
                          data.new_data[name][item]
                        }}</v-col>
                        <v-col class="ma-0 pa-0" cols="12">
                          <v-divider></v-divider>
                        </v-col>
                      </v-row>
                    </template>
                  </v-list>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-row>
        </v-col>
      </v-row>
    </ValidationObserver>
  </CrudForm>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapState } from "vuex";
import CrudForm from "@/components/Crud/CrudForm";
import CrudFormMixin from "@/mixins/crud_form";

export default {
  mixins: [CrudFormMixin],
  components: { ValidationProvider, ValidationObserver, CrudForm },
  computed: {
    ...mapState({
      status: state => state.Terms.status
    })
  },
  created() {},
  data() {
    return {
      storeName: "Notification_prices",
      title: "Notification Prices",
      data: {
        type: "",
        old_data: {},
        new_data: {},
        received_params: {},
        user: "",
        product_price_id: ""
      },
      removed_attributes: [
        "createdAt",
        "updatedAt",
        "__v",
        "coupon_products",
        "price",
        "_id"
      ],
      removed_by_item: {
        product_price:['region_id','product_id','product_price_coupon'],
        product_price_coupon:[],
        coupon_product:[],
        coupon:[]
      },
      attributes_image: ["icon", "picture"],
      attributes_date: ["init_time", "finish_time"]
    };
  },
  methods: {
    namePascalCase(text) {
      let text_separation = text.trim().split("_");
      const words_transform = text_separation.map(
        word => word.charAt(0).toUpperCase() + word.slice(1)
      );
      return words_transform.join(" ");
    },
  }
};
</script>
